<template>
  <el-container>
    <el-header>
      <el-col :span="24">
        <h2>Flujo De Caja Ejecutado</h2>
      </el-col>
    </el-header>

    <el-main class="main">
      <el-form
        :model="formData"
        :rules="rules"
        label-width="300px"
        class="formulario"
      >
        <!-- Grupo de INGRESOS -->
        <el-card shadow="always">
          <h3>FECHA DEL PERIODO A INGRESAR</h3>
          <el-row :gutter="0">
            <el-col :span="12">
              <el-form-item label="Periodo">
                <el-date-picker
                  v-model="formData.acfc_periodo"
                  type="month"
                  format="yyyy-MM"
                  placeholder="Seleccionar mes y año"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <h3>INGRESOS</h3>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                label="Recaudo del Impuesto de Alumbrado Público ESSA"
                class="centered-item"
              >
                <el-input
                  v-model="formData.acfc_recimpessa"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Recaudo Otras Comercializadoras y Cartera">
                <el-input
                  v-model="formData.acfc_reccomcart"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="Rendimientos">
                <el-input
                  v-model="formData.acfc_rendimientos"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Equity Crédito">
                <el-input
                  v-model="formData.acfc_equcre"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <h3>COMPROMISOS DIRECTOS DEL MUNICIPIO</h3>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="Gastos Energía de Alumbrado Público">
                <el-input
                  v-model="formData.acfc_gasenealmpub"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Interventoría">
                <el-input
                  v-model="formData.acfc_interventoria"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="Administración Fiducia">
                <el-input
                  v-model="formData.acfc_admfid"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <h3>INGRESOS PARA EL CONCESIONARIO/COSTOS MUNICIPIO</h3>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="Operación y Mantenimiento a Todo Costo">
                <el-input
                  v-model="formData.acfc_opemantodcos"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Remuneración Inversión">
                <el-input
                  v-model="formData.acfc_reminv"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <h3>INVERSION</h3>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                label="Inversión Reposición y Modernización Sistema a Todo Costo"
              >
                <el-input
                  v-model="formData.acfc_invrepmodsistodcos"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Inversión en Expansiones, Reposiciones, Obras Complementarias"
              >
                <el-input
                  v-model="formData.acfc_invexpreppbrcom"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="Alumbrado Navideño y Ornamental">
                <el-input
                  v-model="formData.acfc_alunavorn"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>

        <!-- Botón de Enviar -->
        <el-row :gutter="20" style="margin-top: 16px;">
          <el-col :span="24">
            <el-button type="primary" @click="enviarDatos()">Enviar</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-main>
  </el-container>
</template>
<script>
  import { sendFlujoCajaEjecutado } from '@/api/acta_flujo_caja'
  import { mapGetters } from 'vuex'
  export default {
    data() {
      return {
        formData: {
          acfc_periodo: new Date(),
          acfc_recimpessa: 0,
          acfc_reccomcart: 0,
          acfc_rendimientos: 0,
          acfc_equcre: 0,
          acfc_gasenealmpub: 0,
          acfc_interventoria: 0,
          acfc_admfid: 0,
          acfc_opemantodcos: 0,
          acfc_reminv: 0,
          acfc_invrepmodsistodcos: 0,
          acfc_invexpreppbrcom: 0,
          acfc_alunavorn: 0
        },
        rules: {
          acfc_periodo: [
            {
              required: true,
              message: 'Este campo es obligatorio',
              trigger: 'blur'
            }
          ],
          acfc_recimpessa: [
            {
              required: true,
              message: 'Este campo es obligatorio',
              trigger: 'blur'
            }
          ],
          acfc_reccomcart: [
            {
              required: true,
              message: 'Este campo es obligatorio',
              trigger: 'blur'
            }
          ],
          acfc_rendimientos: [
            {
              required: true,
              message: 'Este campo es obligatorio',
              trigger: 'blur'
            }
          ],
          acfc_equcre: [
            {
              required: true,
              message: 'Este campo es obligatorio',
              trigger: 'blur'
            }
          ],
          acfc_gasenealmpub: [
            {
              required: true,
              message: 'Este campo es obligatorio',
              trigger: 'blur'
            }
          ],
          acfc_interventoria: [
            {
              required: true,
              message: 'Este campo es obligatorio',
              trigger: 'blur'
            }
          ],
          acfc_admfid: [
            {
              required: true,
              message: 'Este campo es obligatorio',
              trigger: 'blur'
            }
          ],
          acfc_opemantodcos: [
            {
              required: true,
              message: 'Este campo es obligatorio',
              trigger: 'blur'
            }
          ],
          acfc_reminv: [
            {
              required: true,
              message: 'Este campo es obligatorio',
              trigger: 'blur'
            }
          ],
          acfc_invrepmodsistodcos: [
            {
              required: true,
              message: 'Este campo es obligatorio',
              trigger: 'blur'
            }
          ],
          acfc_invexpreppbrcom: [
            {
              required: true,
              message: 'Este campo es obligatorio',
              trigger: 'blur'
            }
          ],
          acfc_alunavorn: [
            {
              required: true,
              message: 'Este campo es obligatorio',
              trigger: 'blur'
            }
          ]
        }
      }
    },
    methods: {
      enviarDatos() {
        this.loading = true
        console.log('Valor de acfc_periodo:', this.formData.acfc_periodo)
        const fecha_periodo = `${this.formData.acfc_periodo.getFullYear()}-${String(
          this.formData.acfc_periodo.getMonth() + 1
        ).padStart(2, '0')}-01`
        console.log('Date:', fecha_periodo)
        const Params = {
          acta_id: 4,
          usua_id: this.usuario.usua_id,
          empr_id: this.empresa.empr_id,
          acfc_periodo: fecha_periodo,
          acfc_recimpessa: this.formData.acfc_recimpessa,
          acfc_reccomcart: this.formData.acfc_reccomcart,
          acfc_rendimientos: this.formData.acfc_rendimientos,
          acfc_equcre: this.formData.acfc_equcre,
          acfc_gasenealmpub: this.formData.acfc_gasenealmpub,
          acfc_interventoria: this.formData.acfc_interventoria,
          acfc_admfid: this.formData.acfc_admfid,
          acfc_opemantodcos: this.formData.acfc_opemantodcos,
          acfc_reminv: this.formData.acfc_reminv,
          acfc_invrepmodsistodcos: this.formData.acfc_invrepmodsistodcos,
          acfc_invexpreppbrcom: this.formData.acfc_invexpreppbrcom,
          acfc_alunavorn: this.formData.acfc_alunavorn
        }

        console.log('Params:', Params)

        sendFlujoCajaEjecutado(Params)
          .then(response => {
            this.loading = false
            this.$message({
              message: 'Flujo ejecutado guardado correctamente',
              type: 'success'
            })
          })
          .catch(error => {
            this.loading = false
            if (error.response.data.status_code == 400) {
              this.$message({
                message: error.response.data.message,
                type: 'error'
              })
            }
            console.log('error: ', error.response.data)
          })
      }
    },
    computed: {
      ...mapGetters(['empresa', 'usuario'])
    }
  }
</script>

<style scoped>
  .main {
    padding: 60px;
  }

  h2 {
    text-align: center;
    margin-bottom: 10px;
  }

  h3 {
    margin-bottom: 10px;
    font-weight: bold;
  }

  .el-card {
    margin-bottom: 10px;
    padding: 10px;
  }

  .formulario .el-form-item__label {
    text-transform: lowercase;
    /* Convertir texto en minúsculas */
    white-space: normal;
    /* Permitir que el texto ocupe varias líneas */
    word-wrap: break-word;
    /* Ajustar el texto largo */
  }
</style>
